// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__30Lo5","subheader":"ReorderModal_subheader__1vuEU","listWrap":"ReorderModal_listWrap__1XNDr"};